import { ApiResponse } from 'apisauce'
import { Buffer } from 'buffer'

import api from '.'

type DataOk = {
  access_token: string
  refresh_token: string
}

type DataError = {
  exception?: string
  reasons?: string
}

export type AuthByUsernameProps = {
  login: string
  password: string
}

function authByUsername({
  login,
  password
}: AuthByUsernameProps): Promise<ApiResponse<DataOk, DataError>> {
  return api.post('auth/login', null, {
    headers: {
      Authorization: `Basic ${Buffer.from(`${login}:${password}`).toString(
        'base64'
      )}`
    }
  })
}

export default { authByUsername }
